export default {
  introduction: {
    label: "Introduction (Max: 150 words)",
    max: 150,
  },
  climate_change: {
    label: "Climate Change Risk Profile (Max: 250 words)",
    max: 250,
  },
  carbon: {
    label: "Carbon Footprint Profile (Max: 150 words)",
    max: 150,
  },
  adaptation: {
    label: "Adaptation (and Mitigation) Measures/Projects (Max: 1,500 words)",
    max: 1500,
  },
  implementation: {
    label: "Implementation Plan (Max: 250 words)",
    max: 250,
  },
};
